import { render, staticRenderFns } from "./CustomTupla.vue?vue&type=template&id=6aa723a0&scoped=true"
import script from "./CustomTupla.vue?vue&type=script&lang=js"
export * from "./CustomTupla.vue?vue&type=script&lang=js"
import style0 from "./CustomTupla.vue?vue&type=style&index=0&id=6aa723a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa723a0",
  null
  
)

export default component.exports